import type { Creds } from "./types";

/**
 * Whether `creds` can still be used without refreshing: it must outlive `now` by more than
 * `thresholdMs`. Missing or unparseable `expiresAt` is treated as fresh — the host chose not to
 * declare an expiry, so we trust the token until a 401 invalidates it rather than churning.
 */
export function isFresh(creds: Creds, now: number, thresholdMs: number): boolean {
  if (!creds.expiresAt) return true;
  const expiresAt = Date.parse(creds.expiresAt);
  if (Number.isNaN(expiresAt)) return true;
  return expiresAt - now > thresholdMs;
}
